<template>
  <LcHeader @left-button-click="navigateBack()">
    <template #headline>
      <slot name="headline">
        <LcLotteryLogo v-bind="{ licensedTerritory, lotteryId }" />
      </slot>
    </template>
  </LcHeader>
</template>

<script lang="ts" setup>
const { licensedTerritory, lotteryId } = await useResultDetails()
const { navigateBack } = useRouterUtils()
</script>
